<script setup lang="ts">
import type { FooterMarkdownContentProps } from './types'

import { Markdown } from '@fond-of/fondof-ui'

const props = defineProps<FooterMarkdownContentProps>()
</script>
<template>
  <Markdown
    :class="props.class"
    :content="props.content"
  />
</template>
